var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4019_405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.6855 19.8869L18.2068 15.4082C18.0047 15.2061 17.7307 15.0938 17.4432 15.0938H16.7109C17.9508 13.508 18.6875 11.5135 18.6875 9.34375C18.6875 4.18223 14.5053 0 9.34375 0C4.18223 0 0 4.18223 0 9.34375C0 14.5053 4.18223 18.6875 9.34375 18.6875C11.5135 18.6875 13.508 17.9508 15.0938 16.7109V17.4432C15.0938 17.7307 15.2061 18.0047 15.4082 18.2068L19.8869 22.6855C20.3092 23.1078 20.992 23.1078 21.4098 22.6855L22.6811 21.4143C23.1033 20.992 23.1033 20.3092 22.6855 19.8869ZM9.34375 15.0938C6.16777 15.0938 3.59375 12.5242 3.59375 9.34375C3.59375 6.16777 6.16328 3.59375 9.34375 3.59375C12.5197 3.59375 15.0938 6.16328 15.0938 9.34375C15.0938 12.5197 12.5242 15.0938 9.34375 15.0938Z",
    fill: "#B6B6B6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4019_405"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/iconSearch.c413ee46a9a77f25e77909f19319efcd.svg";
export { ForwardRef as ReactComponent };